import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import moment from "moment-timezone";
import { STATUS } from "config/constants";
import { getContentDateString } from "utils/contentDisplay";
import styles from "./DashboardDate.css";

export default function DashboardDate(props) {
  const dateString = getContentDateString(props, props.showPublishedDatetime);

  return (
    <div
      className={classNames(styles.root, {
        [styles.locked]: props.lock && props.lock.id,
      })}
    >
      {dateString}
    </div>
  );
}

DashboardDate.propTypes = {
  last_updated: PropTypes.oneOfType([
    PropTypes.instanceOf(moment),
    PropTypes.instanceOf(Date),
  ]).isRequired,
  scheduled_date: PropTypes.oneOfType([
    PropTypes.instanceOf(moment),
    PropTypes.instanceOf(Date),
  ]),
  published_date: PropTypes.oneOfType([
    PropTypes.instanceOf(moment),
    PropTypes.instanceOf(Date),
  ]),
  eta: PropTypes.oneOfType([
    PropTypes.instanceOf(moment),
    PropTypes.instanceOf(Date),
  ]),
  status: PropTypes.oneOf(Object.values(STATUS).map(x => x.slug)),
  in_edits: PropTypes.bool,
  showPublishedDatetime: PropTypes.bool,
  lock: PropTypes.object,
};
